/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getEntitiesBatch} from '../api'

 export const useQueryGetEntitiesBatch = createReactQueryHook('getEntitiesBatch', getEntitiesBatch)
